<template>
  <div :class="['', classes]">
    <paragraph
      :text="label"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="font-bold text-sm mb-1"
    />
    <p>
      <span
        v-for="(text, index) in textArray"
        :key="index"
        :class="spanStyles"
        >{{ text }}</span
      >
    </p>
  </div>
</template>
<script lang="ts" setup>
import { ThemeType } from "@/types/types";
import { computed, toRefs } from "vue";
import Paragraph from "@components/Typography/Paragraph.ce.vue";

const props = withDefaults(
  defineProps<{
    isUmbraco?: boolean;
    themeType: ThemeType;
    label: string;
    textArray: string[];
    classes?: string;
  }>(),
  {
    isUmbraco: false,
    themeType: "light",
  }
);

const { isUmbraco, themeType, label, textArray, classes } = toRefs(props);

const spanStyles = computed(() => {
  const color =
    isUmbraco.value && themeType.value === "dark"
      ? "text-white"
      : isUmbraco.value && themeType.value === "light"
      ? "text-aubergine"
      : "text-typography";
  return `paragraph themeTransition mr-[2px] text-sm ${color} mb-5`;
});
</script>
